import { createDomainAuthUtils } from '@shared/lib/auth-utils'
import {
  setEncryptedSessionStorage,
  getEncryptedSessionStorage,
} from '@shared/lib/crypto-utils'

import type { TClientUserSchema } from '@fingerprinting/types/schemas/auth.schema'

const fingerprintingAuthUtils = createDomainAuthUtils('fingerprinting')

const clientAuthUtils = {
  setAccessToken: (token: string): void => {
    fingerprintingAuthUtils.setAccessToken(token)
  },

  getAccessToken: (): string | null => {
    return fingerprintingAuthUtils.getAccessToken()
  },

  setRefreshToken: (token: string): void => {
    fingerprintingAuthUtils.setRefreshToken(token)
  },

  getRefreshToken: (): string | null => {
    return fingerprintingAuthUtils.getRefreshToken()
  },

  setClientUser: (user: TClientUserSchema): void => {
    setEncryptedSessionStorage('fingerprinting_portal_user', user)
  },

  getUser: (): TClientUserSchema | null => {
    return getEncryptedSessionStorage<TClientUserSchema>('fingerprinting_portal_user')
  },

  clearAuth: (): void => {
    fingerprintingAuthUtils.clearAuth()
  },

  isTokenValid: (token: string | null): boolean => {
    return fingerprintingAuthUtils.isTokenValid(token)
  },

  getTokenExpiration: (token: string | null): number | null => {
    return fingerprintingAuthUtils.getTokenExpiration(token)
  },

  isAuthenticated: (): boolean => {
    return fingerprintingAuthUtils.isAuthenticated()
  },
}

export default clientAuthUtils
